function t(t){setTimeout((function(){throw t}),0)}export{t as hostReportError};
